<template>
  <div :class="classObject">
    <InputfieldLabel
      :class="labelClass"
      :text="label"
      :for="fieldId"
    />
    <InputfieldDescription
      :text="description"
    >
      <slot name="description" />
    </InputfieldDescription>
    <div class="field__content">
      <multiselect
        v-model="valueMutable"
        v-bind="[$attrs, $listeners]"
        :options="items"
        :custom-label="getLabel"
        label="title"
        track-by="id"
        :searchable="searchable"
        :show-labels="(false)"
        :allow-empty="(!required)"
        :placeholder="placeholder"
        :id="fieldId"
        :name="name"
      >
        <!-- Template for selected value -->
        <template
          slot="singleLabel"
          slot-scope="props"
        >
          <template v-if="multilang === true && locale.length">
            {{ props.option.title[locale] }}
          </template>
          <template v-else>
            {{ props.option.title }}
          </template>
        </template>

        <!-- Template for option item -->
        <template
          slot="option"
          slot-scope="props"
        >
          <template v-if="multilang === true && locale.length">
            {{ props.option.title[locale] }}
          </template>
          <template v-else>
            {{ props.option.title }}
          </template>
        </template>
        <span slot="noResult">
          Ei hakutuloksia
        </span>
      </multiselect>
    </div>
    <InputfieldErrors :items="parsedErrors" />
    <InputfieldNotes :text="notes" />
  </div>
</template>

<script>

import InputfieldMixin from '@/components/forms/InputfieldMixin'
import InputfieldLabel from '@/components/forms/InputfieldLabel'
import InputfieldDescription from '@/components/forms/InputfieldDescription'
import InputfieldNotes from '@/components/forms/InputfieldNotes'
import Multiselect from 'vue-multiselect'

export default {
  name: 'InputfieldAutoComplete',
  inheritAttrs: false,
  mixins: [
    InputfieldMixin,
  ],
  components: {
    InputfieldLabel,
    InputfieldDescription,
    InputfieldNotes,
    Multiselect,
  },
  data () {
    return {
      valueMutable: null,
    }
  },
  computed: {
    valueText () {
      if (!this.value) return

      return this.value
    },
  },
  props: {
    labelClass: {
      type: String,
      required: false,
      default () {
        return ''
      },
    },
    searchable: {
      type: Boolean,
      required: false,
      default () {
        return true
      },
    },
    items: {
      type: Array,
      required: false,
      default () {
        return []
      },
    },
    placeholder: {
      type: String,
      required: false,
      default () {
        return ''
      },
    },
    getLabel: {
      type: Function,
      required: false,
      default (item) {
        return item.title
      },
    },
    multilang: {
      type: Boolean,
      required: false,
      default () {
        return false
      },
    },
    locale: {
      type: String,
      required: false,
      default () {
        return 'fi'
      },
    },
  },
  watch: {
    value: {
      deep: true,
      handler (e) {
        this.clearErrors()
        this.$emit('input', e)
        this.valueMutable = e
      },
    },
    valueMutable: {
      deep: true,
      handler (e) {
        this.clearErrors()
        this.$emit('input', e)
      },
    },
  },
  updated () {
    this.valueMutable = this.value
  },
  mounted () {
    this.valueMutable = this.value
  },
}

</script>

<style lang="scss">

</style>
